"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadDTO = void 0;
class DownloadDTO {
    id;
    name;
    originalname;
    mimetype;
    size;
    base64;
    eTag;
}
exports.DownloadDTO = DownloadDTO;
